const eventName = 'watch';

export class Value extends EventTarget {
  #value = null;

  #params = {
    type: undefined,
    nullable: false,
    immediate: false,
    validate: null
  };

  constructor (value, params = {}) {
    super();

    this.#value = value;
    this.#params = Object.assign(this.#params, params);

    if (this.#params.immediate) {
      setTimeout(() => dispatchEvent(this, eventName, { value: this.get() }));
    }
  }

  get() {
    let value = this.#value;
    if (typeof this.#value === 'object' && this.#value !== null) {
      if (this.#value.constructor === Array) {
        value = [...this.#value];
      }
      else {
        value = { ...this.#value };
      }
    }
    return value;
  }

  set(value) {
    let validate = true;

    if (value === null && !this.#params.nullable) {
      validate = false;
    }

    if (validate && this.#params.type && !(this.#params.nullable && value === null)) {
      if (this.#params.type === Boolean && typeof value !== 'boolean') {
        validate = false;
      }
      if (this.#params.type === Number && typeof value !== 'number') {
        validate = false;
      }
      if (this.#params.type === String && typeof value !== 'string') {
        validate = false;
      }
      if (this.#params.type === BigInt && typeof value !== 'bigint') {
        validate = false;
      }
      if (this.#params.type === Symbol && typeof value !== 'symbol') {
        validate = false;
      }
      if (this.#params.type === Function && typeof value !== 'function') {
        validate = false;
      }
      if (this.#params.type === Object && typeof value !== 'object') {
        validate = false;
      }
      if (this.#params.type === Array && value?.constructor !== Array) {
        validate = false;
      }
    }

    if (validate) {
      validate = typeof this.#params.validate === 'function' ? this.#params.validate(this, value) : validate;
    }

    if (validate) {
      const prev = this.get();
      this.#value = value;
      dispatchEvent(this, eventName, { value: this.get(), prev });
    }
    else {
      throw new Error(`Incorrect value of ${value} on Value object.`);
    }
  }

  emit() {
    dispatchEvent(this, eventName, { value: this.get() });
  }
}

export default function value() {
  return new Value(...arguments);
}

function dispatchEvent(proxy, eventName, detail = {}) {
  proxy.dispatchEvent(new CustomEvent(eventName, { detail }));
}
